import styled from "@emotion/styled";
import { motion } from "framer-motion";

const HoverBackground = styled(motion.div)(() => ({
  zIndex: 0,
  willChange: "transform",
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  bottom: 0,
  background: "rgba(0,0,0,0.5)",
}));

export default HoverBackground;
